var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPlayerAiSummary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.68934 6.93934C2.97064 6.65804 3.35217 6.5 3.75 6.5H11.75C12.1478 6.5 12.5294 6.65804 12.8107 6.93934C13.092 7.22064 13.25 7.60217 13.25 8V16C13.25 16.3978 13.092 16.7794 12.8107 17.0607C12.5294 17.342 12.1478 17.5 11.75 17.5H3.75C3.35218 17.5 2.97065 17.342 2.68934 17.0607C2.40803 16.7794 2.25 16.3978 2.25 16V8C2.25 7.60218 2.40804 7.22064 2.68934 6.93934ZM3.75 7.5C3.61739 7.5 3.49021 7.55268 3.39645 7.64645C3.30268 7.74022 3.25 7.86739 3.25 8V16C3.25 16.1326 3.30268 16.2598 3.39645 16.3536C3.49021 16.4473 3.61739 16.5 3.75 16.5H11.75C11.8826 16.5 12.0098 16.4473 12.1036 16.3536C12.1973 16.2598 12.25 16.1326 12.25 16V8C12.25 7.86739 12.1973 7.74022 12.1036 7.64645C12.0098 7.55268 11.8826 7.5 11.75 7.5H3.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61499 2.75C7.48238 2.75 7.35521 2.80268 7.26144 2.89645C7.16767 2.99021 7.11499 3.11739 7.11499 3.25V7C7.11499 7.27614 6.89113 7.5 6.61499 7.5C6.33885 7.5 6.11499 7.27614 6.11499 7V3.25C6.11499 2.85217 6.27303 2.47064 6.55433 2.18934C6.83563 1.90804 7.21717 1.75 7.61499 1.75H20.25C20.6478 1.75 21.0293 1.90803 21.3107 2.18934C21.592 2.47065 21.75 2.85218 21.75 3.25V20.75C21.75 21.1478 21.592 21.5294 21.3107 21.8107C21.0293 22.092 20.6478 22.25 20.25 22.25H7.61499C7.21717 22.25 6.83564 22.092 6.55433 21.8107C6.27303 21.5294 6.11499 21.1478 6.11499 20.75V17C6.11499 16.7239 6.33885 16.5 6.61499 16.5C6.89113 16.5 7.11499 16.7239 7.11499 17V20.75C7.11499 20.8826 7.16767 21.0098 7.26144 21.1036C7.3552 21.1973 7.48238 21.25 7.61499 21.25H20.25C20.3826 21.25 20.5098 21.1973 20.6035 21.1036C20.6973 21.0098 20.75 20.8826 20.75 20.75V3.25C20.75 3.11739 20.6973 2.99021 20.6035 2.89645C20.5098 2.80268 20.3826 2.75 20.25 2.75H7.61499Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.5L20 7.5",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.5H15",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5H15",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.5H15",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.5H15",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.5L20 10.5",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.5L20 13.5",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 16.5,
    x2: 20,
    y2: 16.5,
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89524 15H3.57706L5.58558 9.18182H7.17081L9.17649 15H7.85831L6.40092 10.5114H6.35547L4.89524 15ZM4.81286 12.7131H7.92649V13.6733H4.81286V12.7131ZM11.1069 9.18182V15H9.87678V9.18182H11.1069Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlayerAiSummary);
export default __webpack_public_path__ + "static/media/ic_player_ai_summary.1437e154.svg";
export { ForwardRef as ReactComponent };